import type { IEvent } from "@/core/plugins/Events/Event";
import { AxiosAdapter } from "../../../../../core/services/AxiosAdapter";
import { DITypes } from "@/core/@types/types";
import { injectable, inject, optional } from "inversify";
import type { IHttpTokenInterceptor } from "../../../../../core/services/middleware/HttpTokenInterceptor";
import type { AxiosInstance } from "axios";
import { indicadoresUrl } from "../../../../../core/services/protocols";

@injectable()
export default class IndicadoresHttpClient extends AxiosAdapter {
  constructor(
    @inject(DITypes.EVENT) event: IEvent,
    @inject(DITypes.INTERCEPTOR)
    @optional()
    axiosTokenInterceptor?: IHttpTokenInterceptor<AxiosInstance>
  ) {
    super(event, axiosTokenInterceptor);

    this.setup(indicadoresUrl);
  }
}
